import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'chroaSpathiAbove';
const args = { color: CssVars.ColorFthora };

export class ChroaSpathiAbove extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
